// extracted by mini-css-extract-plugin
export default {"Title":"iStyles_Title__9H4SV","Description":"iStyles_Description__GA6A6","Description2":"iStyles_Description2__-4NYI","ADHDPointerCardTitle":"iStyles_ADHDPointerCardTitle__jg4eU"};